const { locale } = Intl.DateTimeFormat().resolvedOptions()

const useLocale = () => locale

export { useLocale }
